"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));

var _useTheme = _interopRequireDefault(require("@material-ui/styles/useTheme"));

var _hamburger = _interopRequireDefault(require("./hamburger"));

var _mobile = _interopRequireDefault(require("./mobile"));

var _desktop = _interopRequireDefault(require("./desktop"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ReactMenu01 = function ReactMenu01(_ref) {
  var backLabel = _ref.backLabel,
      _ref$desktopSubContai = _ref.desktopSubContainerEvent,
      desktopSubContainerEvent = _ref$desktopSubContai === void 0 ? "click" : _ref$desktopSubContai,
      _ref$desktopSubContai2 = _ref.desktopSubContainerLayoutColumn,
      desktopSubContainerLayoutColumn = _ref$desktopSubContai2 === void 0 ? "horizontal" : _ref$desktopSubContai2,
      iconBottom = _ref.iconBottom,
      iconMenu = _ref.iconMenu,
      iconClose = _ref.iconClose,
      iconLeft = _ref.iconLeft,
      iconRight = _ref.iconRight,
      mainmenu = _ref.mainmenu,
      metamenu = _ref.metamenu,
      _ref$mobileOnly = _ref.mobileOnly,
      mobileOnly = _ref$mobileOnly === void 0 ? false : _ref$mobileOnly,
      _ref$toggleAlign = _ref.toggleAlign,
      toggleAlign = _ref$toggleAlign === void 0 ? "ltr" : _ref$toggleAlign,
      toggleLabel = _ref.toggleLabel,
      onClose = _ref.onClose,
      onOpen = _ref.onOpen;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var theme = (0, _useTheme.default)();
  var bigScreen = (0, _useMediaQuery.default)(theme.breakpoints.up("lg"));

  var handleClose = function handleClose() {
    if (onClose) onClose();
  };

  var handleOpen = function handleOpen() {
    if (onOpen) onOpen();
  };

  var mobileMenu = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_hamburger.default, {
    align: toggleAlign,
    click: function click() {
      setOpen(true);
      handleOpen();
    },
    icon: iconMenu,
    label: toggleLabel
  }), isOpen && /*#__PURE__*/_react.default.createElement(_mobile.default, {
    backLabel: backLabel,
    close: function close() {
      setOpen(false);
      handleClose();
    },
    iconBottom: iconBottom,
    iconClose: iconClose,
    iconRight: iconRight,
    iconLeft: iconLeft,
    mainmenu: mainmenu,
    metamenu: metamenu
  }));

  var desktopMenu = /*#__PURE__*/_react.default.createElement(_desktop.default, {
    desktopSubContainerEvent: desktopSubContainerEvent,
    desktopSubContainerLayoutColumn: desktopSubContainerLayoutColumn,
    iconClose: iconClose,
    mainmenu: mainmenu,
    onClose: handleClose,
    onOpen: handleOpen
  });

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, mobileOnly === false && bigScreen ? desktopMenu : mobileMenu);
};

ReactMenu01.propTypes = {
  backLabel: _propTypes.default.string,
  desktopSubContainerEvent: _propTypes.default.string,
  desktopSubContainerLayoutColumn: _propTypes.default.string,
  iconBottom: _propTypes.default.string,
  iconClose: _propTypes.default.string.isRequired,
  iconLeft: _propTypes.default.string,
  iconMenu: _propTypes.default.string.isRequired,
  iconRight: _propTypes.default.string,
  mainmenu: _propTypes.default.object.isRequired,
  metamenu: _propTypes.default.object,
  mobileOnly: _propTypes.default.bool,
  onClose: _propTypes.default.func,
  onOpen: _propTypes.default.func,
  toggleAlign: _propTypes.default.string,
  toggleLabel: _propTypes.default.string
};
var _default = ReactMenu01;
exports.default = _default;